"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentFile_1 = require("../types/AttachmentFile");
var owa_file_common_1 = require("owa-file-common");
function createUriFiles(entries) {
    var uriList = entries.map(function (entry) {
        return {
            fileType: AttachmentFile_1.AttachmentFileType.Uri,
            name: entry.name,
            type: owa_file_common_1.getExtensionFromFileName(entry.url),
            size: 0,
            uri: entry.url,
        };
    });
    return uriList;
}
exports.default = createUriFiles;
//# sourceMappingURL=createUriFiles.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-attachment-common/lib/utils/createUriFiles.js
// module id = 4045
// module chunks = 100